// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';
import type { ColorScheme } from '../../../../types/theme';

type Props = {
  scheme: ColorScheme,
};

const StyledBullet = styled<any, Theme, Props>('div')`
  ${({ scheme, theme: { list } }) => css`
    text-align: center;

    &:before {
      content: '•';
      color: ${scheme.icons || list.listStyles.dot.color};
      font-size: 1.5em;
      line-height: .9em;
    }
  `}
`;

const Bullet = ({ scheme }: Props) => (
  <StyledBullet scheme={scheme} />
);

export default Bullet;
